<template>
  <div>
    <decision-form />

    <panel>
      <w-button class="btn-secondary" text="Wróć" @click="goBack" />
    </panel>
  </div>
</template>

<script>
import DecisionForm from '@/components/forms/decision/DecisionForm';
import Panel from '@/components/panel/Panel';

// @vuese
// Widok decyzji
// @group Document
export default {
  components: { DecisionForm, Panel },

  methods: {
    // @vuese
    // Wraca do szczegółów dokumentu
    goBack() {
      this.$router.push({ name: 'documentDetails' });
    }
  }
};
</script>
